// import { combineReducers, configureStore } from "@reduxjs/toolkit";
// import { ofsApi } from "src/api/ofsAPI";

// export const store = configureStore({
//     reducer: combineReducers({
//         [ofsApi.reducerPath]: ofsApi.reducer
//     }),
//     middleware:(getDefaultMiddleware) => 
//         getDefaultMiddleware().concat(ofsApi.middleware),
// })
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { ofsApi } from "src/api/ofsAPI";
import alertsReducer, { AlertsState } from "src/providers/Alerts/alertsSlice";
import userReducer, { UserState } from "src/providers/User/userSlice";
 
const rootReducer = combineReducers({
  [ofsApi.reducerPath]: ofsApi.reducer,
  alerts: alertsReducer,
  user: userReducer,
});
 
export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(ofsApi.middleware),
});
 
export interface StoreState {
  alerts: AlertsState;
  user: UserState;
  [ofsApi.reducerPath]: ReturnType<typeof ofsApi.reducer>;
}
export type AppState = StoreState;
export type AppDispatch = typeof store.dispatch;